import { render } from "./BooleanFilter.vue?vue&type=template&id=70b40617"
import script from "./BooleanFilter.vue?vue&type=script&lang=js"
export * from "./BooleanFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanFilter.vue"]])

export default __exports__